/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ComplianceFreelancerReason
 */
export interface ComplianceFreelancerReason {
    /**
     * 
     * @type {string}
     * @memberof ComplianceFreelancerReason
     */
    reason: string;
}

/**
 * Check if a given object implements the ComplianceFreelancerReason interface.
 */
export function instanceOfComplianceFreelancerReason(value: object): value is ComplianceFreelancerReason {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function ComplianceFreelancerReasonFromJSON(json: any): ComplianceFreelancerReason {
    return ComplianceFreelancerReasonFromJSONTyped(json, false);
}

export function ComplianceFreelancerReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComplianceFreelancerReason {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
    };
}

export function ComplianceFreelancerReasonToJSON(value?: ComplianceFreelancerReason | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'reason': value['reason'],
    };
}

